import { useEffect, useState } from "react";
import { bus } from "@/lib/bus";
import { TenantAdminLink } from "@/components/TenantAdminLink";

/**
 * Shown when the API answers 402: the tenant's subscription is in its
 * grace period (read-only), has lapsed, or hit its user limit. Links to
 * Admin → Billing, which stays reachable whatever the subscription state.
 */
export default function BillingBanner() {
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => bus.on("billing:required", (detail) => {
    const d = detail as { message?: string } | undefined;
    setMessage(d?.message ?? "Your subscription needs attention.");
  }), []);

  if (!message) return null;

  return (
    <div role="alert" className="alert alert-danger"
         style={{ margin: 0, borderRadius: 0, display: "flex", gap: 12, alignItems: "center", justifyContent: "space-between" }}>
      <span>{message}</span>
      <span style={{ display: "flex", gap: 8, alignItems: "center" }}>
        <TenantAdminLink to="billing" from="legionella" className="btn btn-primary btn-sm">Go to billing</TenantAdminLink>
        <button className="btn btn-ghost btn-sm" onClick={() => setMessage(null)} aria-label="Dismiss">Dismiss</button>
      </span>
    </div>
  );
}
